/* ═══════════════════════════════════════════════
   LE CELLIER MORVANDIAU, Theme JS
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Hamburger menu ──
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var open = hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ── Active nav link ──
  var currentPath = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(function (a) {
    if (a.getAttribute('href') && currentPath.includes(a.getAttribute('href')) && a.getAttribute('href') !== '/') {
      a.classList.add('active');
    }
  });

  // ── Cart count from Shopify ──
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var el = document.querySelector('.cart-count');
      if (el) el.textContent = '(' + cart.item_count + ')';
    })
    .catch(function () {});

  // ── Add to cart ──
  var addToCartForms = document.querySelectorAll('.product-form-js');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.product-add-btn');
      var originalText = btn.textContent;
      btn.textContent = 'Ajout en cours…';
      btn.disabled = true;

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓ Ajouté au panier';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var el = document.querySelector('.cart-count');
              if (el) el.textContent = '(' + cart.item_count + ')';
            });
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });

  // ── Sélecteur de variante (carte cadeau, formats) ──
  // Met à jour le prix, la référence et le stock max quand la variante change.
  var variantSelect = document.getElementById('variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (!opt) return;

      var priceEl = document.getElementById('product-price');
      if (priceEl) {
        var compare = opt.getAttribute('data-compare');
        priceEl.innerHTML =
          (compare ? '<span class="product-price-was">' + compare + '</span> ' : '') +
          opt.getAttribute('data-price');
      }

      // Image principale : chaque montant de carte cadeau a son visuel
      var mainImg = document.getElementById('product-main-img');
      var newSrc = opt.getAttribute('data-image');
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
        var newAlt = opt.getAttribute('data-image-alt');
        if (newAlt) mainImg.alt = newAlt;
      }

      var skuEl = document.getElementById('product-sku');
      if (skuEl && opt.getAttribute('data-sku')) {
        skuEl.textContent = opt.getAttribute('data-sku');
      }

      var qty = document.getElementById('product-qty');
      if (qty) {
        var max = opt.getAttribute('data-max');
        if (max && parseInt(max, 10) > 0) {
          qty.setAttribute('max', max);
          if (parseInt(qty.value, 10) > parseInt(max, 10)) qty.value = max;
        } else {
          qty.removeAttribute('max');
        }
      }
    });
  }

  // ── Retour de formulaire : amener le visiteur sur le message ──
  // Shopify recharge la page en haut apres l'envoi d'un formulaire de
  // contact. Sur une page longue comme Le Caveau, le formulaire est tout
  // en bas : le visiteur ne voyait ni la confirmation ni l'erreur, et
  // pouvait renvoyer sa demande en croyant que rien ne s'etait passe.
  var messageFormulaire = document.querySelector('.form-succes, .form-erreurs');
  if (messageFormulaire) {
    messageFormulaire.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (messageFormulaire.hasAttribute('tabindex')) { messageFormulaire.focus(); }
  }

  // ── Confirmation d'inscription newsletter ──
  // Shopify renvoie sur ?customer_posted=true après un envoi réussi.
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    document.querySelectorAll('.newsletter-form').forEach(function (wrap) {
      var msg = document.createElement('p');
      msg.className = 'newsletter-success';
      msg.textContent = '✓ Merci, votre inscription est enregistrée.';
      wrap.parentNode.insertBefore(msg, wrap.nextSibling);
      wrap.style.display = 'none';
    });
  }

});
